export default "__VITE_ASSET__CP4adG_G__"